<table
  #tableElement
  class="cg-datatable"
  matSort
  (matSortChange)="sortData($event)"
>
  <ng-container *ngIf="stage === USER_LOADING_STAGE.loading">
    <div class="cg-flex-center" style="padding: 3em">
      <div class="cg-media">
        <div class="cg-media__img">
          <div class="cg-spinner"></div>
        </div>
        <div class="cg-media__bd cg-margin-top-sm">Loading users...</div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="stage === USER_LOADING_STAGE.error">
    <div class="cg-flex-center" style="padding: 3em">
      <div class="cg-error-msg-large">
        <cigna-icon type="exclamation-circle"></cigna-icon>
        <div>Error loading users, please reload to try again.</div>
      </div>
    </div>
  </ng-container>
  <ng-container
    *ngIf="
      stage === USER_LOADING_STAGE.loaded_pending ||
      stage === USER_LOADING_STAGE.loaded_all
    "
  >
    <thead>
      <tr>
        <th
          style="width: 55px"
          class="cg-datatable__header cg-datatable__header-checkbox"
        >
          <!-- {{ 'am.common.userTable.checkboxRowHeader' | translate }} -->
          <input
            class="cg-datatable__header-checkbox-input"
            type="checkbox"
            (change)="selectAllUsers($event)"
            data-test="wam-table-header-checkbox"
          />
        </th>
        <th
          mat-sort-header="lastName"
          class="cg-datatable__header cg-datatable__header--sortable"
          data-test="hdr-user-sortable"
        >
          {{ 'am.common.userTable.userRowHeader' | translate }}
        </th>
        <th
          mat-sort-header="jobRole"
          class="cg-datatable__header cg-datatable__header--sortable"
          data-test="hdr-job-role-sortable"
        >
          {{ 'am.common.userTable.jobRoleRowHeader' | translate }}
        </th>
        <th class="cg-datatable__header">
          <div class="nosort-header-container">
            {{ 'am.common.userTable.tinsHeader' | translate }}
          </div>
        </th>
        <th class="cg-datatable__header" style="width: 255px">
          <div class="nosort-header-container">
            {{ 'am.common.userTable.statusRowHeader' | translate }}
          </div>
        </th>
        <th class="cg-datatable__header" *ngIf="amLob !== LOB_DENTAL">
          <div class="nosort-header-container">Line of business</div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngIf="
          filterText === '' &&
          sortedData.length === 0 &&
          filterGroup === FILTER_GROUP.awaiting
        "
      >
        <td
          data-test="no-awaiting-approval-txt"
          class="cg-datatable__cell--noresults"
          colspan="5"
        >
          No Users Awaiting Approval
        </td>
      </tr>
      <tr *ngIf="filterText !== '' && sortedData.length === 0">
        <td
          data-test="no-result-found-txt"
          class="cg-datatable__cell--noresults"
          colspan="5"
        >
          No Results Found
        </td>
      </tr>
      <tr
        *ngFor="let user of sortedData"
        data-test="tr-manage-user-access-data-table"
      >
        <td class="cg-datatable__cell cg-datatable__cell--centered">
          <input
            type="checkbox"
            (change)="selectUser(user, $event)"
            data-test="wam-table-user-checkbox"
          />
        </td>
        <td class="cg-datatable__cell">
          <cigna-user-summary-item
            [user]="user"
            [showJobRole]="false"
            (viewAccessForUser)="openUserAccessDialog($event)"
          >
          </cigna-user-summary-item>
        </td>
        <td class="cg-datatable__cell">
          <span data-test="wam-table-user-jobrole">{{ user.jobRole }}</span>
        </td>
        <td class="cg-datatable__cell">
          <cigna-user-tins-grouped-item [show]="3" [user]="user">
          </cigna-user-tins-grouped-item>
        </td>
        <td class="cg-datatable__cell">
          <cigna-user-status-item
            [user]="user"
            [amUserId]="amUserId"
            (removeAccessForUser)="openUserRemoveAccessDialog($event)"
            (resetPasswordForUser)="openResetUserPasswordDialog($event)"
          >
          </cigna-user-status-item>
        </td>
        <td class="cg-datatable__cell" *ngIf="amLob !== LOB_DENTAL">
          <cigna-user-lob
            [user]="user"
            [isImpersonator]="isImpersonator"
          ></cigna-user-lob>
        </td>
      </tr>
    </tbody>
  </ng-container>
</table>
